import React from 'react';
import Helmet from 'react-helmet';
import '../assets/scss/init.scss';
// import '../assets/scripts/tongwen_core';
// import '../assets/scripts/tongwen_table_s2t.js';
// import '../assets/scripts/tongwen_table_t2s.js';
// import '../assets/scripts/tongwen_table_pt2s.js';
// import '../assets/scripts/tongwen_table_ps2t.js';

const toTradChinese = (obj) => {
  return TongWen.convert(obj, 'traditional');
}
const toSimpChinese = (obj) => {
  return TongWen.convert(obj, 'simplified');
}

class Layout extends React.Component {
  // constructor(props) {
  //   super(props);
  //   this.state = { isTradChinese: true };
  //   this.translate = this.translate.bind(this);
  // }

  // translate() {
  //   const { isTradChinese } = this.state;
  //   const layout = typeof document !== 'undefined' && document.querySelector('.layout');
  //   const layoutContent = layout && (layout.querySelector('.post-single__inner') || layout.querySelector('.content__inner') || layout.querySelector('.page'));
  //   layoutContent.innerHTML = isTradChinese ? toSimpChinese(layoutContent.innerHTML) : toTradChinese(layoutContent.innerHTML);
  //   this.setState(prevState => ({ isTradChinese: !prevState.isTradChinese }));
  // }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.isTradChinese === this.state.isTradChinese) {
  //     this.setState({ isTradChinese: !this.state.isTradChinese });
  //   }
  // }

  render() {
    const { children } = this.props;
    // const { isTradChinese } = this.state;

    return (
      // <div className={`layout ${!isTradChinese && 'simp'}`}>
      <div className="layout">
        <Helmet defaultTitle="Jason Lam" />
        {children()}
        {/* <span className="layout__translate-button" onClick={this.translate}>{isTradChinese ? '简' : '繁'}</span> */}
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx